// extracted by mini-css-extract-plugin
export default {"wrapper":"Fixed_wrapper__vHnDV"};